module.exports = __webpack_public_path__ + "static/img/9.5ce52b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dhlw/9.png
// module id = 56RT
// module chunks = 0